import { CreatePointRequest, DeletePointByIdRequest, GetPointByIdRequest, GetPointRequest, UpdatePointRequest } from '@aoe/client';
import { createActionGroup, props } from '@ngrx/store';
import { CreatePointResponse, PointAdminDetailResponse, PointAdminListResponse, UpdatePointResponse } from 'src/app/core/interfaces/PointResponse.interface';

export const PointAdminActions = createActionGroup({
    source: 'Admin Point',
    events: {
        // Load
        'Load Points': props<{ payload: GetPointRequest, eventId: string }>(),
        'Load Points Success': props<PointAdminListResponse>(),
        'Load Points Fail': props<PointAdminListResponse>(),

        'Load Point By Id': props<{ payload: GetPointByIdRequest, eventId: string }>(),
        'Load Point By Id Success': props<PointAdminDetailResponse>(),
        'Load Point By Id Fail': props<PointAdminDetailResponse>(),

        // Create
        'Create Point': props<{ payload: CreatePointRequest, eventId: string }>(),
        'Create Point Success': props<CreatePointResponse>(),
        'Create Point Fail': props<UpdatePointResponse>(),

        // Update
        'Update Point': props<{ id: string; payload: UpdatePointRequest, eventId: string }>(),
        'Update Point Success': props<UpdatePointResponse>(),
        'Update Point Fail': props<UpdatePointResponse>(),

        // Delete
        'Delete Point By Id': props<{ payload: DeletePointByIdRequest, eventId: string }>(),
        'Delete Point By Id Success': props<{ id: string }>(),
        'Delete Point By Id Fail': props<{ error: string }>(),
    }
});